module.exports = __webpack_public_path__ + "img/member-title.25365354.png";